import {Component, EventEmitter } from '@angular/core';
import {BaseComponent} from '../../../../shared/base-components/base.component';
import {NMVTISMessageModel} from '../../models/nmvtis-message.model';

@Component({
    selector: 'vehicle-not-found',
    templateUrl: './vehicle-not-found.html',
    inputs: ['nmvtisMessageModel'],
    outputs: ['onSaved']
})

// should be called in case of all the warnings and not just vehicle-not-found

export class VehicleNotFoundComponent extends BaseComponent {

    public dataLoaded = false;
    public message: string;
    public onSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
    public nmvtisMessageModel: NMVTISMessageModel;

    constructor() {
        super();

        // this.businessTransactionNumber = +_route.snapshot.params["id"]; // grab the business transaction from the route.

    }

    ngOnInit() {
        // this.message = "The vehicle was not found on NMVTIS.";
        this.message = this.nmvtisMessageModel.interactionManagerMessageContent;
        this.dataLoaded = true;
    }

    onSaveClick() {
        this.onSaved.emit(true);
    }
}
